<ng-container *ngIf="model">
  <!-- Medium and large devices layout -->
  <div class="row no-gutters h-100 hidden-xs hidden-sm mb-product-line-search-result"
       data-cy="mb-search-product-line">
    <div class="badges-wrapper" data-cy="mb-search-product-line-stamps">
      <span class="badge rounded-pill mr-3"
            [ngClass]="{ 'badge-danger': constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
            'badge-success': constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
            'badge-warning': constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()) }"
            *ngFor="let stamp of stamps">
        <span
          *ngIf="constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
        <span
          *ngIf="constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
        <span
          *ngIf="constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
      </span>
    </div>

    <div class="col-1 mt-1 pl-3 hidden-md mb-search-product-line-code-wrapper"
         data-cy="mb-search-product-line-code"
         [mbCopyToClipboard]="model.code"
         mbShowPopup
         *ngIf="!(isFacetExpanded$ | async)">
      <mb-clipboard-popup role="tooltip" data-cy="mb-search-show-clipboard-popup"></mb-clipboard-popup>
      <div class="cursor-pointer mb-1 copy-to-clipboard d-inline-flex"
           title="Copy to clipboard">
        <img src="assets/icons/svg/copy.svg"
             class="pr-2"
             alt="Copy to clipboard icon"
             title="Copy to clipboard"
             aria-label="Copy product code"
             data-cy="mbSearchProductLineCodeIcon"/>
        <span [ngClass]="[!isChild && 'font-weight-bold' || '', 'mb-search-product-line-code']"
              [innerHTML]="model.code | safeHtml"></span>
      </div>
      <p class="mb-search-product-line-rstatus"
         data-cy="mb-search-product-line-rstatus"
         [innerHTML]="model.regulatoryStatus | safeHtml"
         *ngIf="model.regulatoryStatus">
      </p>
    </div>

    <div class="pl-3 mt-1 position-static"
         [ngClass]="(isFacetExpanded$ | async) && 'mb-search-facet-expanded-product-family-line' || 'col-md-2 col-lg-3'"
         data-cy="mb-search-product-line-name">
      <!-- Only show this on medium size devices -->
      <div class="d-sm-none d-md-block d-lg-none cursor-pointer mb-1 mb-search-product-line-code-wrapper"
           [ngClass]="!(isFacetExpanded$ | async) && 'd-lg-none' || 'd-lg-block'"
           [mbCopyToClipboard]="model.code"
           mbShowPopup>
        <mb-clipboard-popup role="tooltip"
                            data-cy="mb-search-show-clipboard-popup"></mb-clipboard-popup>
        <img src="assets/icons/svg/copy.svg"
             class="pr-2"
             alt="Copy to clipboard icon"
             title="Copy to clipboard"
             aria-label="Copy product code"
             data-cy="mb-searchProductLineCodeIcon"/>
        <span [ngClass]="[!isChild && 'font-weight-bold' || '', 'mb-search-product-line-code']"
              title="Copy to clipboard"
              [innerHTML]="model.code | safeHtml">
        </span>
      </div>
      <div class="pt-md-2 pt-lg-0"
           [ngClass]="(isFacetExpanded$ | async) && 'pt-lg-2' || ''">
        <a class="cursor-pointer"
           [ngClass]="!isChild && 'font-weight-bold' || ''"
           [routerLink]="url"
           [fragment]="fragment"
           [mbProductClick]="model"
           [innerHTML]="model.name | safeHtml"
           [attr.data-analytics-src]="dataAnalyticsClickSource"
           data-analytics="product-title">
        </a>
        <span class="ml-1"
              [innerHTML]="'(' + model.clinicalReferenceNumber + ')' | safeHtml"
              *ngIf="model.clinicalReferenceNumber"></span>
      </div>
      <div class="tw-mb-2">
        <span *ngIf="!isChild && model.alternativeNames" class="tw-italic">{{'mbproduct.synonyms'|mbTranslate}}: {{model.alternativeNames.join(', ')}}</span>
      </div>
      <p class="d-sm-none d-md-block d-lg-none mb-search-product-line-rstatus"
         data-cy="mb-search-product-line-rstatus"
         [ngClass]="!(isFacetExpanded$ | async) && 'd-lg-none' || 'd-lg-block'"
         [innerHTML]="model.regulatoryStatus | safeHtml"
         *ngIf="model.regulatoryStatus">
      </p>
      <!-- End only show this on medium size devices -->
    </div>

    <div class="col mt-1"
         [ngClass]="(isFacetExpanded$ | async) && 'mb-search-dynamic-column-padding-left' || 'pl-3'"
         *ngFor="let info of model.searchInformationMap?.entry">
      <span class="mb-search-product-line-keys text-left"
            [innerHTML]="info?.key | safeHtml"></span>
      <br/>
      <span class="mb-search-product-line-values"
            [innerHTML]="info?.value | safeHtml"></span>
    </div>

    <div *ngIf="!model.searchInformationMap?.entry"
         class="col mt-1 px-3"></div>

    <div class="text-left mt-1"
         [ngClass]="(isFacetExpanded$ | async) && 'mb-search-facet-expanded-product-price' || 'mb-search-dynamic-column-padding-left mb-one-and-half-column-width'"
         data-cy="mb-search-product-line-price">
      <span class="mb-search-product-line-keys text-left"
            [innerHTML]="'searchResultItem.price' | mbTranslate"></span>
      <br/>
      <div class="font-weight-bold"
           [innerHTML]="!hasPriceOnRequest && (model.priceData?.formattedValue | safeHtml) || ('mbcommon.onRequest' | mbTranslate)">
      </div>
    </div>

    <div class="col-2 ml-auto mt-1 pr-md-1 pr-lg-3 text-right mb-search-product-line-actions"
         data-cy="mb-search-product-line-actions">
      <mb-add-to-cart [addToCartForm]="addToCartForm"
                      [clickSource]="dataAnalyticsClickSource"
                      [hasPriceOnRequest]="hasPriceOnRequest"
                      [product]="model"
                      [productCode]="model.code"
                      [ngClass]="{'mb-search-product-line-shrink' : isFacetExpanded$ | async}">
      </mb-add-to-cart>
    </div>
  </div>

  <!-- Small devices layout -->
  <div class="row no-gutters h-100 hidden-md hidden-lg hidden-xl mb-product-line-search-result"
       data-cy="mb-search-product-line-sm">
    <div class="col-12 my-auto position-static">
      <div class="row no-gutters my-1 pb-3"
           data-cy="mb-search-product-line-code-sm">
        <div class="col-6 px-2 position-static">
          <div class="cursor-pointer mb-1 mb-search-product-line-code-wrapper"
               [mbCopyToClipboard]="model.code"
               mbShowPopup>
            <mb-clipboard-popup role="tooltip"
                                data-cy="mb-search-show-clipboard-popup-sm"></mb-clipboard-popup>
            <div class="badges-wrapper"
                 data-cy="mb-search-product-line-stamps">
              <ng-container *ngFor="let stamp of stamps">
                <span class="badge rounded-pill mr-3"
                      [ngClass]="{ 'badge-danger': constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
                      'badge-success': constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
                      'badge-warning': constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()) }">
                  <span
                    *ngIf="constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
                  <span
                    *ngIf="constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
                  <span
                    *ngIf="constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
                </span>
              </ng-container>
            </div>
            <img src="assets/icons/svg/copy.svg"
                 class="pr-2"
                 alt="Copy to clipboard icon"
                 title="Copy to clipboard"
                 aria-label="Copy product code"
                 data-cy="mb-search-product-line-code-icon-sm"/>
            <span [ngClass]="[!isChild && 'font-weight-bold' || '', 'mb-search-product-line-code']"
                  title="Copy to clipboard"
                  [innerHTML]="model.code | safeHtml">
            </span>
          </div>
          <p class="mb-search-product-line-rstatus"
             data-cy="mb-search-product-line-rstatus-sm"
             [innerHTML]="model.regulatoryStatus | safeHtml"
             *ngIf="model.regulatoryStatus">
          </p>
        </div>

        <div class="col-6 px-2"
             data-cy="mb-search-product-line-name-sm">
          <div>
            <a class="cursor-pointer"
               [ngClass]="!isChild && 'font-weight-bold' || ''"
               [routerLink]="url"
               [fragment]="fragment"
               [mbProductClick]="model"
               [innerHTML]="model.name | safeHtml"
               [attr.data-analytics-src]="dataAnalyticsClickSource"
               data-analytics="product-title">
            </a>
            <span class="ml-1"
                  [innerHTML]="'(' + model.clinicalReferenceNumber + ')' | safeHtml"
                  *ngIf="model.clinicalReferenceNumber"></span>
          </div>
          <div class="tw-mb-2">
            <span *ngIf="!isChild && model.alternativeNames" class="tw-italic">{{'mbproduct.synonyms'|mbTranslate}}: {{model.alternativeNames.join(', ')}}</span>
          </div>
        </div>
      </div>

      <div class="row no-gutters my-1"
           data-cy="mb-search-product-line-size-sm"
           *ngFor="let info of model.searchInformationMap?.entry">
        <div class="col-6 px-2">
          <p class="mb-0 mb-search-product-line-keys"
             [innerHTML]="info?.key | safeHtml"></p>
        </div>
        <div class="col-6 px-2 mb-search-product-line-values">
          <p class="mb-0"
             [innerHTML]="info?.value | safeHtml"></p>
        </div>
      </div>

      <div class="row no-gutters my-1"
           data-cy="mb-search-product-line-price-sm">
        <div class="col-6 my-auto px-2">
          <p class="mb-0 mb-search-product-line-keys"
             [innerHTML]="'searchResultItem.price' | mbTranslate"></p>
        </div>
        <div class="col-6 my-auto px-2 mb-search-product-line-values">
          <p class="mb-0 font-weight-bold"
             [innerHTML]="!hasPriceOnRequest && (model.priceData?.formattedValue | safeHtml) || ('mbcommon.onRequest' | mbTranslate)">
          </p>
        </div>
      </div>

      <div class="row no-gutters my-1">
        <div class="col-12 my-auto px-2 text-center"
             data-cy="mb-search-product-line-actions-sm">
          <mb-add-to-cart [addToCartForm]="addToCartForm"
                          [clickSource]="dataAnalyticsClickSource"
                          [hasPriceOnRequest]="hasPriceOnRequest"
                          [product]="model"
                          [productCode]="model.code">
          </mb-add-to-cart>
        </div>
      </div>
    </div>
  </div>
</ng-container>
